import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const STORAGE_KEY = 'rx2go-theme'

// One-shot migration: existing users may have `system` saved in
// localStorage from when the picker offered it. With enableSystem=false
// next-themes would still honour the stored value and look at OS
// preference for class application — but the picker never lets the
// user change away from it, so the value would silently linger. Wipe
// it so the defaultTheme kicks in.
if (typeof window !== 'undefined') {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored === 'system') {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch { /* ignore — private mode etc. */ }
}

export function ThemeProvider({ children }: Props) {
  return (
    <NextThemesProvider
      attribute="class"
      // OSPROD-94: light is the default theme for new users. The manual
      // toggle and any stored preference (storageKey below) are unchanged.
      defaultTheme="light"
      enableSystem={false}
      themes={['light', 'dark']}
      disableTransitionOnChange
      storageKey={STORAGE_KEY}
    >
      {children}
    </NextThemesProvider>
  )
}
